export const chatsMap = {
  sendingTips: '正在生成答案，请稍后再试'
}
export const ROBOT_AVATAR_DEFAULT =
  'https://static5.yingsaidata.com/mip/img/8844682-history-robot.png'
export const ROBOT_AVATAR_DONE = 'https://static5.yingsaidata.com/mip/img/4072670-new-robot.gif'
export const ROBOT_AVATAR_SENDING =
  'https://static5.yingsaidata.com/mip/img/2828888-sending-robot.gif'
